// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9d1b923","555":"325f59d1","732":"bb4d1463"}[chunkId] + ".chunk.js";
};